module.exports = {
  INIT: 'init',
  PAID: 'paid',
  STARTED: 'started',
  ENDED: 'ended',
  RATED: 'rated',
  CANCELLED: 'cancelled',
};
